import HorizontalListView from "../../../_utils/horizontal-list-view/HorizontalListView";
import {useContext} from "react";
import QRCodeStyleViewContext from "../../../QRCodeStyleViewContext";

/**
 * Corners component
 * @author Kacper Faber
 * @since 0.1.9
 */
function CornersComponent() {
    /**
     * setActiveView from context
     * @author Kacper Faber
     * @since 0.1.9
     */
    const {setActiveView} = useContext(QRCodeStyleViewContext);

    /**
     * On more button in HorizontalListView is clicked.
     * @author Kacper Faber
     * @since 0.1.9
     */
    const onMoreButtonClick = () => {
        setActiveView('more-corners');
    };

    return (
        <div>
            <HorizontalListView
                label="Narożniki"
                moreButton="Więcej ustawień"
                onMoreButtonClick={onMoreButtonClick}
            />
        </div>
    );
}

export default CornersComponent;